// extracted by mini-css-extract-plugin
export default {"search":"materials_search__Bbh3Y","fieldList":"materials_fieldList__fig0w","field":"materials_field__GoCBw","count":"materials_count__t3dIs","list":"materials_list__6+6V2"};